// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPbm {
    static getAttributeTypeMap() {
        return MedicalBiPbm.attributeTypeMap;
    }
}
MedicalBiPbm.discriminator = undefined;
MedicalBiPbm.additionalProperties = false;
MedicalBiPbm.attributeTypeMap = [
    {
        "name": "exists",
        "baseName": "exists",
        "type": "boolean"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPbm.js.map